import { ReactElement } from 'react';
import { Grid, SelectChangeEvent, useEventCallback } from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { useFormikContext } from 'formik';
import { useListener } from 'shell/hooks/use-bus';
import { EventFormPractice } from 'practice/constants/research-state-enum';
import { ResearchActForm } from 'civil-status/view-models/research-form';
import OperatorList from '../../shared/operator-list';
import { ItemVM } from 'shell/view-models/item';
import { DatePicker } from '@mui/lab';
import PmiTextField from 'shell/components/shared/text-field';
import ListEmergencyRegister from 'civil-status/components/shared/list-emergency-register';

const FormFilter = (): ReactElement => {
  const formContext = useFormikContext<ResearchActForm>();

  useListener<ResearchActForm>(EventFormPractice.UpdateForm, (form) => {
    formContext.setValues({ ...formContext.values, ...form });
  });

  const onChangeOperator = useEventCallback((event: SelectChangeEvent<string>) => {
    formContext.setFieldValue('codOperator', event.target.value);
  });

  const handleListEmergencyRegister = useEventCallback((item?: ItemVM) => {
    formContext.setFieldValue('emergencyRegister', item?.id?.toString());
  });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <OperatorList
          label="Operatore"
          onChange={onChangeOperator}
          value={formContext.values.codOperator || ''}
          codiceStatoEvento={formContext.values.stateAct || undefined}
          // disabled={!formContext.values.stateAct}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <ListEmergencyRegister
          label="Registro di emergenza"
          value={formContext.values?.emergencyRegister || ''}
          onChange={handleListEmergencyRegister}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <DatePicker
          label="Data decorrenza - inizio"
          aria-label="Data decorrenza - inizio"
          value={formContext.values?.dataStart || null}
          onChange={(date) => {
            formContext.setFieldValue('dataStart', date);
          }}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="dataStart"
              fullWidth
              helperText={formContext.errors?.dataStart}
              error={formContext.touched?.dataStart && Boolean(formContext.errors?.dataStart)}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <DatePicker
          label="Data decorrenza - fine"
          aria-label="Data decorrenza - fine"
          value={formContext.values?.dataEnd || null}
          onChange={(date) => {
            formContext.setFieldValue('dataEnd', date);
          }}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="dataEnd"
              fullWidth
              helperText={formContext.errors?.dataEnd}
              error={formContext.touched?.dataEnd && Boolean(formContext.errors?.dataEnd)}
            />
          )}
        />
      </Grid>
      <Grid item container spacing={2} xs={12} justifyContent="space-between" display="flex">
        <Grid item container spacing={2} xs={12} justifyContent="flex-end" display="flex">
          <Grid item xs={12} md={2}>
            <PmiButton
              variant="contained"
              color="secondary"
              fullWidth
              onClick={() => formContext.resetForm()}
            >
              Pulisci
            </PmiButton>
          </Grid>
          <Grid item xs={12} md={2}>
            <PmiButton variant="contained" color="secondary" fullWidth type="submit">
              Cerca
            </PmiButton>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

FormFilter.displayName = 'Practice Research Emergency - Filter Practice - Form Filter component';

export default FormFilter;
